/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import styles from './Tag.module.scss.js';

const Tag = (props) => {
    const { children, className = '' } = props;
    return jsx("strong", Object.assign({ className: `${styles.tag} ${className}` }, { children: children }));
};

export { Tag };
//# sourceMappingURL=Tag.js.map
